import axios from 'axios';
import { API_PREFIX } from './lelyBackend/config';

const axiosInstance = axios.create({
  baseURL: API_PREFIX,
});

export default axiosInstance;
